import { initialIframeState, IIframeState } from "@edp-store/state/iframe.state";
import { EIframeActions, IframeActions } from "@edp-store/actions/iframe.actions";

export function iframeReducers(state = initialIframeState, action: IframeActions): IIframeState {
    switch (action.type) {
        case EIframeActions.SetIframe: {
            return {
                ...state,
                iframe: {
                    route: action.payload,
                    preload: action.preload,
                    reload: action.reload,
                },
            };
        }
        case EIframeActions.ShowIframeModal: {
            return {
                ...state,
                iframeModal: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
